<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card" v-bind:id="getId()" style="float:left; width:200px; margin-left:15px;">
    <div class="card-header bg-dark text-white header-elements-inline">
      <h6 class="card-title">{{config.text}}</h6>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" @click="removeMe" data-action="remove"></a>
        </div>
      </div>
    </div>
    <div class="card-body bg-blue text-center text-primary card-img-top" style="background-image: url(/Images/map.png); background-size: contain;">
      <div class="filter-title text-center" style="background-color: rgb(182, 232, 116);">
      <img src="/images/filter_icons/icon-location.png" width="40">
      </div>
    </div>

  </div>
</template>

<script>

  var config =
  {
    customstyle: "background-color:#92D050",
    customclass: "",
    abbreviation: "T1",
    data: 8,
    text: "Team 1",
    icon: null

  }

  export default {
    name: "display-location",
    components: {
      
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      },
    },
    data() {
      return {
        config
      };
    },
    
    methods: {
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getId());
      },
      setConfig(config) {
        this.config = config;
      }
    },
    computed: {
      
    },
    mounted() {
     
    },

    created: function () {

    },

    watch: {
     
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>
  .card-header.bg-dark {
    background-color: #f6f7f7 !important;
    color: black !important;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .filter-title {
    position: relative;
    width: 60px;
    height: 60px;
    display: block;
    line-height: 60px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    background-color: black;
    color: white;
    text-align: center;
    font-size: 2em;
    margin-left:50px;
    margin-top:20px;
  }

  .card-body{
      min-height:150px;
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/filter/displayers/display-location.vue